<template>
  <div class="containerWrapper">
    <div class="container details">
      <div class="row dashBoardOrdersWrapper">
        <div class="col-md-4">
          <h2><span class="fontIcon"><font-awesome-icon :icon="['fal', 'file-alt']"></font-awesome-icon></span> {{ msg }}</h2>
        </div>
        <div class="content-section implementation dataview-demo">
          <DataTable class="orderlist" stateStorage="session" stateKey="containerOrdersList" :autoLayout="false" :value="orders" data-key="id" :selection.sync="selectedOrder" @row-select="orderDetails(selectedOrder, ordersSchema)" selectionMode="single" :filters="filters" :paginator="true" :rows="40">
            <template #header>
              <div style="text-align: left">
                <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
                <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
              </div>
            </template>
            <Column field="state" header="Status" filterMatchMode="in" :sortable="true">
              <template #body="slotProps">
                <div :class="[slotProps.data.state]">
                  <span>{{slotProps.data.state}}</span>
                </div>
              </template>
              <template #filter>
                <MultiSelect v-model="filters['state']" :options="filterOptions" optionLabel="label" optionValue="value" placeholder="Filtrera.." />
              </template>
            </Column>
            <Column field="startDate" header="Startdatum" :sortable="true">
              <template #body="slotProps" >
                {{formatDate(slotProps.data.data.startDate)}}
              </template>
            </Column>
            <Column field="truck" header="Lastbil" :sortable="true">
              <template #body="slotProps" >
                {{getTruckName(slotProps.data.data.truck)}}
              </template>
            </Column>
            <Column field="avcs" header="Plats" :sortable="true">
              <template #body="slotProps" >
                {{getContainers(slotProps.data.data.avcs)}}
              </template>
            </Column>
             <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button icon="pi pi-ban" @click="archiveOrder(slotProps.data.id)" />
                </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <div class="orderButtonsWrapper container">
      <div class="row">
        <div class="col-md-12">
          <Button class="p-button-success" label="Skapa ny" @click="onCreate()" icon="pi pi-check"></Button>
        </div>
      </div>
    </div>
    <Toast position="topright" />
  </div>
</template>
<script>
import 'primeflex/primeflex.css'
import Toast from 'primevue/toast'
import DataViewPrime from 'primevue/dataview'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import MultiSelect from 'primevue/multiselect'
import Column from 'primevue/column'
import Button from 'primevue/button'
import moment from 'moment'
export default {
  name: 'ContainerOrdersList',
  components: {
    'DataView': DataViewPrime,
    InputText,
    MultiSelect,
    Toast,
    DataTable,
    Column,
    Button,
    moment,
    'Dropdown': Dropdown
  },
  data () {
    return {
      msg: 'Container ordrar',
      activeBtn: 'all',
      orders: [],
      ordersSchema: {},
      trucks: [],
      layout: 'list',
      sortKey: null,
      sortOrder: null,
      sortField: null,
      selectedOrder: null,
      filters: {},
      sortOptions: [
        {label: 'Nyast', value: '!data_DateLoadingEarly'},
        {label: 'Äldst', value: 'data_DateLoadingEarly'}
      ],
      selectedFilter: null,
      filterOptions: [
        {label: 'Nya', value: 'ny'},
        {label: 'Uppdaterade', value: 'uppdaterad'},
        {label: 'Accepterade', value: 'accepterad'},
        {label: 'Skickade', value: 'skickad'},
        {label: 'Aktiva', value: 'aktiv'},
        {label: 'Avslutade', value: 'avslutad'},
        {label: 'Fakturerade', value: 'fakturerad'},
        {label: 'Redo för fakturering', value: 'fakturaredo'}
      ]
    }
  },
  props: {
    id: ''
  },
  async mounted () {
    var response = await this.getOrders()
    this.orders = response.orders.filter((el) => el.state !== 'makulerad')
    this.ordersSchema = response.schema
    this.orderTypes = await this.getOrderTypes()
    this.trucks = await this.getTrucks()
  },
  methods: {
    onCreate () {
      this.$router.push({ name: 'ContainerOrderCreate', params: {type: 'container', schema: this.ordersSchema} })
    },
    setComment (internal, external) {
      let comments = ''
      if (internal !== undefined) {
        comments = internal
      }
      if (external !== undefined) {
        comments += ' ' + external
      }
      return comments
    },
    getTruckName (truckId) {
      if (truckId !== undefined) {
        var trucks = this.trucks
        if (trucks.length > 0) {
          var truck = trucks.find(truck => {
            return truck.id === truckId
          })
          return truck.data.regnbr
        }
      }
    },
    getContainers (containers) {
      if (containers.length > 0) {
        let strContainers = ''
        for (var i = 0; i < containers.length; i++) {
          strContainers += containers[i].name + ' '
        }
        return strContainers
      }
    },
    async filterOrders (btnState) {
      this.activeBtn = btnState
      var response = await this.getOrders()
      if (btnState !== 'all') {
        this.orders = response.orders.filter((el) => el.state === btnState)
      } else {
        this.orders = response.orders.filter((el) => el.state !== 'makulerad')
      }
    },
    formatDate (theDate) {
      return moment(theDate).format('YYYY-MM-DD')
    },
    orderDetails (order, ordersSchema) {
      this.$router.push({ name: 'ContainerOrderDetails', params: { id: order.id, schema: ordersSchema } })
    },
    async getTrucks () {
      let response = await this.$http.get('api/objectdatas/objectdescriptionid/5')
      return response.data
    },
    async getOrders () {
      let response = await this.$http.get('/api/orders/by-type/' + this.$props.id)
      return response.data
    },
    async getOrderTypes () {
      let response = await this.$http.get('/api/orders/types')
      return response.data
    },
    archiveOrder (id) {
      let message = 'Vill du arkivera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$http
            .put('/api/orders/' + id + '/changestate/arkiverad')
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order arkiverad', life: 3000})
              const i = this.orders.map(item => item.id).indexOf(id)
              this.orders.splice(i, 1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onSortChange (event) {
      this.sortField = event
      if (this.sortKey === event) {
        this.sortKey = null
        this.sortOrder = -1
      } else {
        this.sortKey = event
        this.sortOrder = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/ContainerOrdersList.vue